import React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import { useIsMobile } from "@replo/design-system/hooks/use-mobile";
import twMerge from "@replo/design-system/utils/twMerge";
import { ProductTypeCard } from "@v2/features/products/components/ProductTypeCard";
import { PRODUCT_TYPE_OPTIONS } from "@v2/features/products/constants/product-type-options";
import { ArrowLeft } from "lucide-react";

interface ProductTypeSelectorProps {
  onSelectType: (productType: string) => void;
  onBack?: () => void;
}

export function ProductTypeSelector({
  onSelectType,
  onBack,
}: ProductTypeSelectorProps) {
  const isMobile = useIsMobile();

  return (
    <div
      className={twMerge(
        "flex flex-col items-center w-full",
        isMobile ? "gap-8 justify-start py-6" : "gap-14 justify-center",
      )}
    >
      <div className="flex flex-col gap-4 items-center justify-center text-center">
        <div className="text-3xl font-semibold leading-7 text-default">
          Add your first product
        </div>
        <div className="text-muted header-h4 font-normal">
          What are you selling?
        </div>
      </div>
      <div
        className={twMerge(
          "grid gap-4 w-full",
          isMobile ? "grid-cols-1" : "grid-cols-3",
        )}
      >
        {PRODUCT_TYPE_OPTIONS.map((option) => (
          <ProductTypeCard
            key={`${option.value}-${option.title}`}
            title={option.title}
            description={option.description}
            icon={option.icon}
            color={option.color}
            onClick={() => onSelectType(option.value)}
          />
        ))}
      </div>
      {onBack && (
        <div className="flex w-full justify-start">
          <Button
            variant="secondary"
            size="base"
            startEnhancer={<ArrowLeft />}
            onClick={onBack}
          >
            Back
          </Button>
        </div>
      )}
    </div>
  );
}
